/* Aura story page: step navigation (button, swipe, tap, wheel, keys), preloading, review carousel, funnel events with the ad of origin */
(function () {
  var root = document.querySelector('[data-aura-story]');
  if (!root) return;

  var qs = new URLSearchParams(location.search);
  function remember(key, val) {
    try {
      if (val) sessionStorage.setItem(key, val);
      return val || sessionStorage.getItem(key) || '';
    } catch (e) { return val || ''; }
  }
  var origin = {
    ad_concept: remember('aura_ad', qs.get('utm_content')) || 'direct',
    ad_campaign: remember('aura_campaign', qs.get('utm_campaign')) || '',
    ad_source: remember('aura_source', qs.get('utm_source')) || ''
  };

  function track(name, extra) {
    var data = { ad_concept: origin.ad_concept, ad_campaign: origin.ad_campaign, ad_source: origin.ad_source };
    if (extra) for (var k in extra) data[k] = extra[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data));
    if (typeof window.fbq === 'function') window.fbq('trackCustom', name, data);
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, data); } catch (e) {}
  }

  var steps = Array.prototype.slice.call(root.querySelectorAll('.st-step'));
  var segs = Array.prototype.slice.call(root.querySelectorAll('.st-progress span'));
  var back = root.querySelector('[data-story-back]');
  var skip = root.querySelector('[data-story-skip]');
  var cur = 0, lockUntil = 0;

  function load(step) {
    var bg = step && step.querySelector('.st-bg[data-src]');
    if (!bg) return;
    bg.style.setProperty('--bg-img', "url('" + bg.getAttribute('data-src') + "')");
    bg.removeAttribute('data-src');
  }

  function sync() {
    segs.forEach(function (s, i) { s.classList.toggle('is-done', i <= cur); });
    if (back) back.hidden = cur === 0;
    if (skip) skip.hidden = cur === steps.length - 1;
  }

  function go(i, via) {
    if (i < 0 || i >= steps.length || i === cur) return;
    var now = Date.now();
    if (now < lockUntil) return;
    lockUntil = now + 420;
    var from = steps[cur], to = steps[i];
    if (via && i === cur + 1) track('step_' + (cur + 1) + '_complete', { via: via });
    from.classList.add('is-leaving');
    from.classList.remove('is-active');
    setTimeout(function () { from.classList.remove('is-leaving'); }, 380);
    load(to);
    load(steps[i + 1]);
    to.classList.add('is-active');
    to.scrollTop = 0;
    cur = i;
    sync();
    root.classList.add('st--moved');
  }

  root.querySelectorAll('[data-story-next]').forEach(function (b) {
    b.addEventListener('click', function () { go(cur + 1, 'button'); });
  });
  if (back) back.addEventListener('click', function () { go(cur - 1, null); });
  if (skip) skip.addEventListener('click', function () { track('offer_skip', { from_step: cur + 1 }); go(steps.length - 1, null); });
  root.querySelectorAll('[data-story-offer]').forEach(function (b) {
    b.addEventListener('click', function () { track('offer_click'); });
  });

  /* Swipe and tap, like Stories: swipe up or tap the right side to advance, swipe down or tap the left edge to go back */
  var NO_GESTURE = 'a,button,input,select,textarea,label,[data-carousel],[data-dot],.st-hatch';
  function atBottom(el) { return el.scrollTop + el.clientHeight >= el.scrollHeight - 72; }
  function atTop(el) { return el.scrollTop <= 2; }
  var t0 = null, lastTouch = 0;
  root.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { t0 = null; return; }
    var p = e.touches[0], step = steps[cur];
    t0 = { x: p.clientX, y: p.clientY, t: Date.now(), bottom: atBottom(step), top: atTop(step), skip: !!e.target.closest(NO_GESTURE) };
  }, { passive: true });
  root.addEventListener('touchend', function (e) {
    lastTouch = Date.now();
    if (!t0) return;
    var p = e.changedTouches[0], dx = p.clientX - t0.x, dy = p.clientY - t0.y, dt = Date.now() - t0.t, step = steps[cur];
    var start = t0; t0 = null;
    if (Math.abs(dy) > 45 && Math.abs(dy) > Math.abs(dx) * 1.2 && dt < 900) {
      if (dy < 0 && start.bottom && atBottom(step)) go(cur + 1, 'swipe');
      else if (dy > 0 && start.top && atTop(step)) go(cur - 1, null);
      return;
    }
    if (start.skip || Math.abs(dx) > 10 || Math.abs(dy) > 10 || dt > 400) return;
    var r = step.getBoundingClientRect(), rel = (p.clientX - r.left) / (r.width || 1);
    if (rel >= 0.5) go(cur + 1, 'tap');
    else if (rel <= 0.25) go(cur - 1, null);
  }, { passive: true });

  /* Mouse click on the side areas (desktop) */
  root.addEventListener('click', function (e) {
    if (Date.now() - lastTouch < 800 || e.pointerType === 'touch') return;
    if (e.target.closest(NO_GESTURE) || !e.target.closest('.st-step')) return;
    var r = steps[cur].getBoundingClientRect(), rel = (e.clientX - r.left) / (r.width || 1);
    if (rel >= 0.5) go(cur + 1, 'tap');
    else if (rel <= 0.25) go(cur - 1, null);
  });

  /* Wheel and keyboard (desktop) */
  root.addEventListener('wheel', function (e) {
    var step = steps[cur];
    if (e.deltaY > 30 && atBottom(step)) go(cur + 1, 'wheel');
    else if (e.deltaY < -30 && atTop(step)) go(cur - 1, null);
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.target.closest && e.target.closest('input,textarea,select')) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'PageDown') go(cur + 1, 'key');
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'PageUp') go(cur - 1, null);
  });

  /* First-visit hint under the first button */
  var firstNext = steps[0] && steps[0].querySelector('[data-story-next]');
  if (firstNext) {
    var hint = document.createElement('p');
    hint.className = 'st-hint';
    hint.innerHTML = '<svg class="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 15l-6-6-6 6"/></svg>Tap or swipe up to keep reading';
    firstNext.insertAdjacentElement('afterend', hint);
  }

  function preload() {
    var urls = [];
    steps.forEach(function (s) {
      var bg = s.querySelector('.st-bg[data-src]');
      if (bg) urls.push(bg.getAttribute('data-src'));
    });
    root.querySelectorAll('img[loading="lazy"]').forEach(function (img) { urls.push(img.currentSrc || img.src); });
    (function next() {
      var u = urls.shift();
      if (!u) return;
      var im = new Image();
      im.onload = im.onerror = next;
      im.src = u;
    })();
  }
  if (document.readyState === 'complete') preload(); else window.addEventListener('load', preload);

  var car = root.querySelector('[data-carousel]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
  if (car && dots.length) {
    var setDot = function (n) { dots.forEach(function (d, i) { d.classList.toggle('is-active', i === n); }); };
    car.addEventListener('scroll', function () {
      setDot(Math.min(dots.length - 1, Math.round(car.scrollLeft / (car.clientWidth || 1))));
    }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { car.scrollTo({ left: i * car.clientWidth, behavior: 'smooth' }); });
    });
    var drag = null;
    car.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      drag = { x: e.clientX, left: car.scrollLeft };
      car.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) { if (drag) car.scrollLeft = drag.left - (e.clientX - drag.x); });
    window.addEventListener('pointerup', function () { drag = null; car.classList.remove('is-dragging'); });
  }

  load(steps[0]);
  load(steps[1]);
  steps[0].classList.add('is-active');
  sync();
  track('story_view', { step: 1 });
})();
